import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  BiLogoFacebookCircle,
  BiLogoInstagram,
  BiLogoLinkedinSquare,
  BiLogoYoutube,
} from 'react-icons/bi';
import { FaXTwitter } from 'react-icons/fa6';

export function CyberFooter() {
  const [glitchText, setGlitchText] = useState(false);
  
  // Randomly trigger glitch effect on company name
  useEffect(() => {
    const interval = setInterval(() => {
      setGlitchText(true);
      setTimeout(() => setGlitchText(false), 200);
    }, 5000);
    
    return () => clearInterval(interval);
  }, []);

  return (
    <footer className="bg-purple-950/90 border-t-2 border-cyan-400 px-[5%] py-12 relative overflow-hidden">
      {/* Animated grid background */}
      <div 
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: `
            linear-gradient(to right, #39ff14 1px, transparent 1px),
            linear-gradient(to bottom, #39ff14 1px, transparent 1px)
          `,
          backgroundSize: '20px 20px',
          animation: 'grid-scroll 20s linear infinite'
        }}
      />
      
      <style jsx>{`
        @keyframes grid-scroll {
          0% { transform: translate(0, 0); }
          100% { transform: translate(-20px, -20px); }
        }
      `}</style>

      <div className="container relative z-10">
        <div className="grid grid-cols-1 gap-x-[4vw] gap-y-12 pb-12 lg:grid-cols-[1fr_0.5fr]">
          <div>
            <div className="mb-6 font-['VT323']">
              <p className="mb-1 text-sm font-semibold text-cyan-400">[LOCATION_DATA]:</p>
              <p className={`mb-5 text-sm text-cyan-200 ${glitchText ? 'glitch-text' : ''}`}>
                OMNIGEIST_LLC<br />
                COORDINATES: 25.7617° N, 80.1918° W<br />
                SECTOR: MIAMI_FL_33126<br />
                REGION: UNITED_STATES
              </p>
              <p className="mb-1 text-sm font-semibold text-cyan-400">[COMMS_CHANNEL]:</p>
              <a
                href="mailto:info@omnigeist.com"
                className="block text-sm text-cyan-200 hover:text-cyan-400 transition-colors"
              >
                info@omnigeist.com
              </a>
            </div>
          </div>
          <div className="grid grid-cols-1 items-start gap-x-6 gap-y-10 md:grid-cols-2 md:gap-x-8 md:gap-y-4">
            <div>
              <h3 className="mb-4 text-sm font-semibold text-fuchsia-400 font-['VT323']">[AI_SYSTEMS_ACCESS]</h3>
              <ul className="space-y-2">
                <li className="py-2 text-sm font-['VT323']">
                  <a href="https://codeium.com/windsurf" target="_blank" rel="noopener noreferrer" className="text-cyan-200 hover:text-cyan-400 transition-colors">&gt; WINDSURF_IDE</a>
                </li>
                <li className="py-2 text-sm font-['VT323']">
                  <a href="https://www.cursor.com/" target="_blank" rel="noopener noreferrer" className="text-cyan-200 hover:text-cyan-400 transition-colors">&gt; CURSOR_EDITOR</a>
                </li>
                <li className="py-2 text-sm font-['VT323']">
                  <a href="https://claude.ai/" target="_blank" rel="noopener noreferrer" className="text-cyan-200 hover:text-cyan-400 transition-colors">&gt; CLAUDE_AI</a>
                </li>
                <li className="py-2 text-sm font-['VT323']">
                  <a href="https://chatgpt.com/" target="_blank" rel="noopener noreferrer" className="text-cyan-200 hover:text-cyan-400 transition-colors">&gt; CHATGPT</a>
                </li>
                <li className="py-2 text-sm font-['VT323']">
                  <a href="https://sora.com/" target="_blank" rel="noopener noreferrer" className="text-cyan-200 hover:text-cyan-400 transition-colors">&gt; SORA_AI</a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="mb-4 text-sm font-semibold text-fuchsia-400 font-['VT323']">[DEV_RESOURCES]</h3>
              <ul className="space-y-2">
                <li className="py-2 text-sm font-['VT323']">
                  <a href="https://aistudio.google.com/" target="_blank" rel="noopener noreferrer" className="text-cyan-200 hover:text-cyan-400 transition-colors">&gt; GOOGLE_AI_STUDIO</a>
                </li>
                <li className="py-2 text-sm font-['VT323']">
                  <a href="http://relume.io/" target="_blank" rel="noopener noreferrer" className="text-cyan-200 hover:text-cyan-400 transition-colors">&gt; RELUME_IO</a>
                </li>
                <li className="py-2 text-sm font-['VT323']">
                  <a href="https://github.com/microsoft/semantic-kernel" target="_blank" rel="noopener noreferrer" className="text-cyan-200 hover:text-cyan-400 transition-colors">&gt; SEMANTIC_KERNEL</a>
                </li>
                <li className="py-2 text-sm font-['VT323']">
                  <a href="https://github.com/lllyasviel/Fooocus" target="_blank" rel="noopener noreferrer" className="text-cyan-200 hover:text-cyan-400 transition-colors">&gt; FOOOCUS</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="h-px w-full bg-cyan-400/30" />
        <div className="flex flex-col items-center justify-between gap-y-4 pt-8 md:flex-row">
          <div className="text-center text-sm md:text-left font-['VT323']">
            <div className="text-cyan-200">
              [SYS_TIME: {new Date().getFullYear()}] OMNIGEIST_RIGHTS_SECURED
            </div>
            <div className="mt-1">
              <Link 
                to="/" 
                className="text-[#39ff14] hover:underline inline-block"
                style={{
                  textShadow: '0 0 5px #39ff14, 0 0 10px #39ff14',
                }}
              >
                &gt;&gt; RETURN_TO_REALITY &lt;&lt;
              </Link>
            </div>
          </div>
          <div className="flex flex-wrap justify-center gap-x-8 gap-y-2 text-center text-sm text-cyan-200 font-['VT323']">
            <Link to="/privacy-policy" className="hover:text-cyan-400 transition-colors">[PRIVACY_PROTOCOL]</Link>
            <Link to="/terms-of-service" className="hover:text-cyan-400 transition-colors">[SERVICE_TERMS]</Link>
            <Link to="/cookie-policy" className="hover:text-cyan-400 transition-colors">[COOKIE_POLICY]</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default CyberFooter;
